import { render, staticRenderFns } from "./OP_ByHCCPrintableV28.vue?vue&type=template&id=0f8ca484&scoped=true&"
import script from "./OP_ByHCCPrintableV28.vue?vue&type=script&lang=js&"
export * from "./OP_ByHCCPrintableV28.vue?vue&type=script&lang=js&"
import style0 from "./OP_ByHCCPrintableV28.vue?vue&type=style&index=0&id=0f8ca484&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8ca484",
  null
  
)

export default component.exports